import axios from 'axios';
export default {
    HEADER_KEY : 'X-ACCESS-TOKEN',
    TOKEN : 'token',

    getToken () {
        return window.localStorage.getItem(this.TOKEN);
    },

    setToken (token) {
        window.localStorage.setItem(this.TOKEN, token);
        this.setAxiosToken();
    },

    removeToken () {
        window.localStorage.removeItem(this.TOKEN);
        delete axios.defaults.headers.common[this.HEADER_KEY];
    },

    setAxiosToken () {
        if (this.getToken()) {
            axios.defaults.headers.common[this.HEADER_KEY] = this.getToken();
        }
    },
};
